import { useCarrito } from "../context/CarritoContext";
import { Link, useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";


export default function Carrito() {
  const { carrito, setCarrito } = useCarrito();
  const navigate = useNavigate();

  // Eliminar producto por índice
  const eliminarDelCarrito = (index) => {
    const nuevoCarrito = carrito.filter((_, i) => i !== index);
    setCarrito(nuevoCarrito);
  };

  // Calcular total
  const obtenerTotal = () => {
    return carrito.reduce((total, item) => {
      const precioNumerico = parseFloat(item.precio.replace("$", "").replace(".", ""));
      return total + precioNumerico;
    }, 0);
  };

  return (
    <div className="p-8 max-w-[800px] mx-auto mt-24">
      <h1 className="text-2xl font-bold mb-6 text-yellow-900 text-center">Carrito</h1>

      {carrito.length === 0 ? (
        <p className="text-center text-gray-600">Tu carrito está vacío.</p>
      ) : (
        <>
          <ul className="space-y-6">
            {carrito.map((item, i) => (
              <li
                key={i}
                className="border p-4 rounded-md shadow flex items-center gap-4 justify-between"
              >
                <div className="flex items-center gap-4">
                  <img
                    src={item.img}
                    alt={item.nombre}
                    className="w-24 h-24 object-cover rounded"
                  />
                  <div>
                    <h3 className="text-lg font-semibold text-yellow-900">{item.nombre}</h3>
                    <p className="text-sm text-gray-700">Talle: {item.talle}</p>
                    <p className="text-md font-semibold text-gray-800">{item.precio}</p>
                  </div>
                </div>
                <button
                  onClick={() => eliminarDelCarrito(i)}
                  className="text-yellow-900 hover:text-red-600 transition"
                  title="Eliminar del carrito"
                >
                  <Trash2 size={22} strokeWidth={1.5} />
                </button>
              </li>
            ))}
          </ul>

          {/* Total y botones */}
          <div className="mt-8 space-y-4 text-center">
            <p className="text-xl font-bold text-yellow-900">
              Total: ${obtenerTotal().toLocaleString("es-AR")}
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-4">
              <Link
                to="/productos"
                className="bg-white border border-yellow-800 text-yellow-800 px-6 py-2 rounded-md hover:bg-yellow-800 hover:text-white transition"
              >
                Seguir comprando
              </Link>
              <button
                onClick={() => navigate("/checkout")}
                className="bg-yellow-800 text-white px-6 py-2 rounded-md hover:bg-yellow-900 transition"
              >
                Comprar ahora
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}